import {useMutation} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import {useClientsContext} from 'src/pages/clients/contexts/ClientsContext'
import api, {CreateOrEditClient, PatchClient} from 'src/services/api'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'

export default function useUpdateClient() {
  const {enqueueSnackbar} = useSnackbar()
  const {reloadClients} = useClientsContext()

  const mutation = useMutation({
    mutationFn: async ({clientId, body}: {clientId: number; body: CreateOrEditClient}) => {
      const patchClient = new PatchClient(clientId, body)
      await api.client.updateOne(patchClient)
    },
    onSuccess: async () => {
      reloadClients()
      // await client.invalidateQueries({queryKey: [QueryKeyEnum.CLIENTS]}) // TODO: refactor clients grid table to use query clients and make this invalidate work
      enqueueSnackbar('Cliente atualizado com sucesso', {variant: 'success'})
    },
    onError: (error) => {
      handleErrorWithSnackbar(enqueueSnackbar, error, 'Não conseguimos atualizar o cliente no momento')
    },
  })
  return mutation
}
